import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      q: "Is Halvera a travel platform or booking site?",
      a: "No.\nHalvera can coordinate travel when needed, but it exists to manage continuity, access, and resolution when plans change or complexity appears."
    },
    {
      q: "Does Halvera offer perks, benefits, or discounts?",
      a: "No.\nHalvera may provide access to trusted providers or preferred pathways when appropriate, but it is not a perks program or benefits catalog.\n\nMembers don't join for deals — they join so disruption stops being their problem."
    },
    {
      q: "Can Halvera be used for leisure travel?",
      a: "Yes.\n\nLeisure is optional.\nDisruption is not.\n\nHalvera supports both, without being built around either."
    },
    {
      q: "Is Halvera a concierge service?",
      a: "No.\n\nConcierge services execute requests.\nHalvera assumes responsibility — especially when situations change, plans break, or stakes are high."
    },
    {
      q: "Is Halvera a corporate benefit or perk?",
      a: "No.\n\nHalvera is access infrastructure.\nCompanies sponsor access to reduce disruption for critical roles — without variable spend, payroll exposure, or administrative complexity."
    },
    {
      q: "What happens when something goes wrong?",
      a: "Members don't restart, re-explain, or escalate across vendors.\n\nThey pass it to Halvera — and keep moving."
    },
    {
      q: "Who is Halvera for?",
      a: "Halvera is for people and organizations that value calm, reliability, and continuity.\n\nIt is not designed for those seeking deals, occasional convenience, or self-service tools."
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <section className="pt-32 sm:pt-40 lg:pt-56 pb-12 sm:pb-16 lg:pb-24 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-12">
          <h1 className="text-3xl sm:text-4xl lg:text-6xl font-bold text-gray-900 mb-12 sm:mb-16 lg:mb-20 text-center">
            FAQ
          </h1>
          
          <div className="space-y-3 sm:space-y-4">
            {faqs.map((faq, index) => (
              <div 
                key={index}
                className="border-2 border-gray-200 rounded-lg overflow-hidden hover:border-red-600 transition-all"
              >
                <button
                  onClick={() => setOpenIndex(openIndex === index ? null : index)}
                  className="w-full px-5 sm:px-6 lg:px-8 py-4 sm:py-5 lg:py-6 flex items-center justify-between text-left cursor-pointer"
                >
                  <span className="text-base sm:text-lg font-semibold text-gray-900 pr-3 sm:pr-4">
                    {faq.q}
                  </span>
                  <i className={`ri-arrow-${openIndex === index ? 'up' : 'down'}-s-line text-xl sm:text-2xl text-gray-600 flex-shrink-0`}></i>
                </button>
                {openIndex === index && (
                  <div className="px-5 sm:px-6 lg:px-8 pb-4 sm:pb-5 lg:pb-6">
                    <p className="text-sm sm:text-base text-gray-700 font-normal leading-relaxed whitespace-pre-line">
                      {faq.a}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="mt-12 sm:mt-14 lg:mt-16 text-center">
            <Link 
              to="/apply"
              className="inline-block bg-red-600 text-white px-7 sm:px-8 py-3 sm:py-4 rounded-lg text-sm sm:text-base font-semibold hover:bg-red-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              Apply for Access
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
